import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import './AdminNav.css';

// The Layout's "Admin" tab lands on /admin/orgs and there was no way to move
// between admin sections without editing the URL. This sub-nav sits at the top
// of each admin page so the sections are one click apart. `end` on Functions
// stops "/admin" matching every admin path.
const SECTIONS = [
    { to: '/admin/orgs', label: 'Organisations' },
    { to: '/admin/emails', label: 'Emails' },
    { to: '/admin', label: 'Functions', end: true },
];

const AdminNav = () => {
    const { pathname } = useLocation();
    return (
        <nav className="fs admin-subnav" aria-label="Admin sections">
            {SECTIONS.map((s) => {
                const active = s.end ? pathname === s.to : pathname.startsWith(s.to);
                return (
                    <NavLink key={s.to} to={s.to} className={`admin-subnav-link ${active ? 'on' : ''}`}>
                        {s.label}
                    </NavLink>
                );
            })}
        </nav>
    );
};

export default AdminNav;
